module.exports = __webpack_public_path__ + "img/background-todos-mobile.7cf029c7.jpg";